import { isNil } from 'lodash';

/**
 * A relay quantity without the NUMERIC scale: '25.000' -> '25', '0.500' -> '0.5'. Anything that is
 * not a number (e.g. 'Multiple') renders as received.
 */
const formatRelayQuantity = (value) => {
  if (isNil(value)) return 'N/A';

  const asNumber = Number(value);

  return Number.isFinite(asNumber) ? String(asNumber) : String(value);
};

export default formatRelayQuantity;
